import { useMutation } from '@tanstack/react-query';
import { apiPost } from '../client';
import type { PresignRequest, PresignResponse } from '../types';

// useRequestPresign — backend POST /uploads/presign.
// Returns the upload URL + object_key. The caller is responsible for the
// actual PUT to the presigned URL (kept out of the axios pipeline so
// our JWT header / response interceptor do not leak into S3).
export function useRequestPresign() {
  return useMutation({
    mutationFn: (body: PresignRequest) => apiPost<PresignResponse>('/uploads/presign', body),
  });
}

// putToPresignedUrl — direct PUT with the headers the backend listed
// as required. We deliberately avoid axios so the response interceptor
// (refresh-on-401) and the Bearer header are NOT applied to S3.
export async function putToPresignedUrl(
  url: string,
  file: Blob,
  requiredHeaders: Record<string, string> | undefined,
): Promise<void> {
  const headers: Record<string, string> = {
    'Content-Type': file.type || 'application/octet-stream',
    ...(requiredHeaders ?? {}),
  };
  const res = await fetch(url, { method: 'PUT', headers, body: file });
  if (!res.ok) {
    throw new Error(`upload_failed_${res.status}`);
  }
}
